import React, { useState } from 'react';
import './Music.css';

const videos = [
  { title: '1. Tristan et Sam', url: 'https://www.youtube.com/embed/eF10XvOAP0U?si=lJ9mzAky_EGIXHv2://youtu.be/eF10XvOAP0U?si=lJ9mzAky_EGIXHv2' },
  { title: '2. Grand-papa aime', url: 'https://www.youtube.com/embed/KKfonTqQRzs?si=ON6HgMI5SHAwb4Or' },
  { title: '3. Tombe la pluie', url: 'https://www.youtube.com/embed/dyXYWKp4-xk?si=l_An3tsdiG4ycFnw' },
  { title: '4. Cléa et Juliette', url: 'https://www.youtube.com/embed/br_Jp7DQu7E?si=l0n9dRRPg_yxKwlq' },
  { title: '5. Les petits pois', url: 'https://www.youtube.com/embed/HfFcqC6Gvqg?si=Gr6HhObxB0YWrXAc' },
  { title: '6. Saute Crapaud', url: 'https://www.youtube.com/embed/8AhGUcK_P8Q?si=DDt34fZNTEpeJrXW' },
  { title: '7. Frère Jacques', url: 'https://www.youtube.com/embed/8YUq9g8EJW8?si=Eo59NYznyPi6sz4P' },
  { title: '8. Au clair de la lune', url: 'https://www.youtube.com/embed/lczycOpdC_Q?si=1E-JVDzTCC6uzOeg' },
  { title: '9. D’la gomme', url: 'https://www.youtube.com/embed/jomfgsv7o2w?si=MuYyMGLQWQKbm-fq' },
  { title: '10. La piscine', url: 'https://www.youtube.com/embed/zfPgB0czYbI?si=TNChzJ3ZY2URENvY' },
  { title: '11. Le chalet m’appelle', url: 'https://www.youtube.com/embed/skfbuYGIggQ?si=aYeMjkxquNPnE14w' },
  { title: '12. Les roches', url: 'https://www.youtube.com/embed/eeSE2DW0f0o?si=VB3Z2xfPYZ9-XtN8' },
  { title: '13. Swimming', url: 'https://www.youtube.com/embed/D6fA4qyW3eI?si=oiEp9np83NtazH79' }
];

const Music = () => {
  const [index, setIndex] = useState(0);

  const handlePrev = () => {
    setIndex((i) => (i === 0 ? videos.length - 1 : i - 1));
  };

  const handleNext = () => {
    setIndex((i) => (i === videos.length - 1 ? 0 : i + 1));
  };

  return (
    <div className="music-section" id="musique">
      <div className="music-content">
        <div className="music-left">
          <h2 className="section-title">Musique</h2>
          <div className="music-intro">
            <p>
              La vie me chante des chansons<br />
              Les mots tourbillonnent dans ma tête<br />
              Jusqu’à ce que je les couche sur du papier.<br />
              Un air de musique m’envahit<br />
              Jusqu’à ce que je la chante ou que je la crie.<br />
              Les deux se joignent et s’éloignent,<br />
              Dans une valse ou un tango.<br />
              Les deux se métamorphosent, se complètent et prennent vie.<br />
              À pied, en voiture, en train ou en avion<br />
              La vie me chante des chansons.<br />
              La vie me chante des chansons.<br />
              Que je partage avec mes petits-enfants,<br />
              Ma famille et mes amis..<br />
              <br /> 
              Jacques Seguin
            </p>
          </div>
        </div>

        <div className="music-player">
          <iframe
            className="video-frame"
            src={videos[index].url}
            title={videos[index].title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
          <div className="navigation">
            <button onClick={handlePrev}>←</button>
            <span>{videos[index].title}</span>
            <button onClick={handleNext}>→</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Music;
